import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.subCategoryItem = {
    width: [12, 12, 6, 3, 3],
};

categoryDetailSubCategoriesStyles.container = {
    css: css`
        padding-bottom: 50px;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = {
    ...categoryDetailSubCategoriesStyles.subCategoryNameLinkItem,
    css: css`
        ${categoryDetailSubCategoriesStyles.subCategoryNameLinkItem?.css}
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    justify-content: start;
                `,
                css`
                    justify-content: start;
                `,
                css`
                    justify-content: start;
                `,
            ])}
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    ...categoryDetailSubCategoriesStyles.subCategoryNameLink,
    color: colorStrings.primaryMain,
    css: css`
        padding: 8px;
    `,
};
